import {Component, Input, OnInit} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";
import {Lead} from "../../models/lead.model";

@Component({
  selector: 'app-lead-details',
  templateUrl: './lead-details.component.html',
  styleUrls: ['./lead-details.component.scss'],
})
export class LeadDetailsComponent implements OnInit {

  @Input() lead: Lead;
  @Input() title;
  @Input() type: 'lead' | 'referral' = 'lead';
  status: string;
  leadStatus: any;


  constructor(public commonUtils: CommonUtils,
              private modalController: ModalController) {
  }

  ngOnInit() {
    console.log(this.lead);
    this.status = this.commonUtils.getOrderStatusLabel(this.lead.status);
    this.leadStatus = this.commonUtils.getLeadStatusLabel(this.lead.status.toString());
  }

  onClose() {
    this.modalController.dismiss();
  }

  getModelName() {
    return this.type === 'lead' ? 'leada' : 'polecenia';
  }
}



